
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as index5Ewxe7E4ogMeta } from "/codebuild/output/src3764178759/src/pages/index.vue?macro=true";
import { default as aboutaUncaMY9JgMeta } from "/codebuild/output/src3764178759/src/pages/about.vue?macro=true";
import { default as dataL7kOK4S6DOMeta } from "/codebuild/output/src3764178759/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionFdv9IOgZnVMeta } from "/codebuild/output/src3764178759/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningXsXX2gS4tMMeta } from "/codebuild/output/src3764178759/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyYSlL5cPxLhMeta } from "/codebuild/output/src3764178759/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account0QQla3hpYfMeta } from "/codebuild/output/src3764178759/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueTdIZ8l1fG0Meta } from "/codebuild/output/src3764178759/src/pages/account-settings/statue.vue?macro=true";
import { default as supportpy00xzo8hpMeta } from "/codebuild/output/src3764178759/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsLPDg8vUBEPMeta } from "/codebuild/output/src3764178759/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountNHVu493XLhMeta } from "/codebuild/output/src3764178759/src/pages/activate-account.vue?macro=true";
import { default as companyxau0kaadKhMeta } from "/codebuild/output/src3764178759/src/pages/admin/company.vue?macro=true";
import { default as consentsl2ytyl4hsIMeta } from "/codebuild/output/src3764178759/src/pages/admin/consents.vue?macro=true";
import { default as leadsqdRxiybJ3eMeta } from "/codebuild/output/src3764178759/src/pages/admin/leads.vue?macro=true";
import { default as payments50DlpcC1XZMeta } from "/codebuild/output/src3764178759/src/pages/admin/payments.vue?macro=true";
import { default as premiumoNnWpaAm8UMeta } from "/codebuild/output/src3764178759/src/pages/admin/premium.vue?macro=true";
import { default as profilesqjicTPlcfbMeta } from "/codebuild/output/src3764178759/src/pages/admin/profiles.vue?macro=true";
import { default as usersmFieOqlYVVMeta } from "/codebuild/output/src3764178759/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordmUe8nXOKT2Meta } from "/codebuild/output/src3764178759/src/pages/change-password.vue?macro=true";
import { default as _91id_93wceTo1qzSeMeta } from "/codebuild/output/src3764178759/src/pages/chat/[id].vue?macro=true";
import { default as aio2jyOQN1w9Meta } from "/codebuild/output/src3764178759/src/pages/chat/ai.vue?macro=true";
import { default as indexmQv9p0o8b4Meta } from "/codebuild/output/src3764178759/src/pages/chat/index.vue?macro=true";
import { default as chatPHwbLEdlUcMeta } from "/codebuild/output/src3764178759/src/pages/chat.vue?macro=true";
import { default as _91id_93MwJZyP55rpMeta } from "/codebuild/output/src3764178759/src/pages/client/profile/[id].vue?macro=true";
import { default as indexro0XvZqul4Meta } from "/codebuild/output/src3764178759/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93ZzfGPyFn1aMeta } from "/codebuild/output/src3764178759/src/pages/contacts/[id].vue?macro=true";
import { default as indexNpeWlBqnfTMeta } from "/codebuild/output/src3764178759/src/pages/contacts/index.vue?macro=true";
import { default as contactsylbUMlENYwMeta } from "/codebuild/output/src3764178759/src/pages/contacts.vue?macro=true";
import { default as _91userId_93kthFjp9aXkMeta } from "/codebuild/output/src3764178759/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexziO3ARJNj1Meta } from "/codebuild/output/src3764178759/src/pages/login/index.vue?macro=true";
import { default as register_45successv3a4m7AE5TMeta } from "/codebuild/output/src3764178759/src/pages/login/register-success.vue?macro=true";
import { default as loginHH4MrGRzyOMeta } from "/codebuild/output/src3764178759/src/pages/login.vue?macro=true";
import { default as logoutBtWbpDFKKXMeta } from "/codebuild/output/src3764178759/src/pages/logout.vue?macro=true";
import { default as consentsRMbXxZkpy9Meta } from "/codebuild/output/src3764178759/src/pages/manager/consents.vue?macro=true";
import { default as integrationsp8KZaC48PwMeta } from "/codebuild/output/src3764178759/src/pages/manager/integrations.vue?macro=true";
import { default as leadsKDSVJDdWzwMeta } from "/codebuild/output/src3764178759/src/pages/manager/leads.vue?macro=true";
import { default as paymentsu2sxIrhc3WMeta } from "/codebuild/output/src3764178759/src/pages/manager/payments.vue?macro=true";
import { default as profileruIXVFK2LpMeta } from "/codebuild/output/src3764178759/src/pages/manager/profile.vue?macro=true";
import { default as teamyEtKekouS6Meta } from "/codebuild/output/src3764178759/src/pages/manager/team.vue?macro=true";
import { default as indexNVN8px0Ec3Meta } from "/codebuild/output/src3764178759/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientKHJKtTCt9fMeta } from "/codebuild/output/src3764178759/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src3764178759/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceMvGnjZsEAvMeta } from "/codebuild/output/src3764178759/src/pages/marketplace.vue?macro=true";
import { default as subscribehdtctNx2TnMeta } from "/codebuild/output/src3764178759/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clienteLLkQRHrY8Meta } from "/codebuild/output/src3764178759/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientlZ3fc4qJScMeta } from "/codebuild/output/src3764178759/src/pages/orders/my.client.vue?macro=true";
import { default as privacyN6wFfeQ8DuMeta } from "/codebuild/output/src3764178759/src/pages/privacy.vue?macro=true";
import { default as indexTreGPBbYgcMeta } from "/codebuild/output/src3764178759/src/pages/recover/index.vue?macro=true";
import { default as successREfcOAikyQMeta } from "/codebuild/output/src3764178759/src/pages/register/success.vue?macro=true";
import { default as _91id_93euJhbnybNRMeta } from "/codebuild/output/src3764178759/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexq4AV2CRfxrMeta } from "/codebuild/output/src3764178759/src/pages/sales/profile/index.vue?macro=true";
import { default as statueN4enxyAqnaMeta } from "/codebuild/output/src3764178759/src/pages/statue.vue?macro=true";
import { default as successlfBWpMkO6iMeta } from "/codebuild/output/src3764178759/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubccsntgJ5k0Meta } from "/codebuild/output/src3764178759/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubccsntgJ5k0 } from "/codebuild/output/src3764178759/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index5Ewxe7E4ogMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutaUncaMY9JgMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutaUncaMY9JgMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsLPDg8vUBEPMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsLPDg8vUBEPMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src3764178759/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountNHVu493XLhMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountNHVu493XLhMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyxau0kaadKhMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyxau0kaadKhMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsl2ytyl4hsIMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsl2ytyl4hsIMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsqdRxiybJ3eMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsqdRxiybJ3eMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: payments50DlpcC1XZMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: payments50DlpcC1XZMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumoNnWpaAm8UMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumoNnWpaAm8UMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesqjicTPlcfbMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesqjicTPlcfbMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersmFieOqlYVVMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersmFieOqlYVVMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordmUe8nXOKT2Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordmUe8nXOKT2Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/change-password.vue")
  },
  {
    name: chatPHwbLEdlUcMeta?.name,
    path: "/en/chat",
    meta: chatPHwbLEdlUcMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93wceTo1qzSeMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aio2jyOQN1w9Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexmQv9p0o8b4Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatPHwbLEdlUcMeta?.name,
    path: "/pl/chat",
    meta: chatPHwbLEdlUcMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93wceTo1qzSeMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aio2jyOQN1w9Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexmQv9p0o8b4Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93MwJZyP55rpMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93MwJZyP55rpMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexro0XvZqul4Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexro0XvZqul4Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/client/profile/index.vue")
  },
  {
    name: contactsylbUMlENYwMeta?.name,
    path: "/en/contacts",
    meta: contactsylbUMlENYwMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93ZzfGPyFn1aMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexNpeWlBqnfTMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsylbUMlENYwMeta?.name,
    path: "/pl/contacts",
    meta: contactsylbUMlENYwMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93ZzfGPyFn1aMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexNpeWlBqnfTMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93kthFjp9aXkMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93kthFjp9aXkMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index5Ewxe7E4ogMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: index5Ewxe7E4ogMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/index.vue")
  },
  {
    name: loginHH4MrGRzyOMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src3764178759/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexziO3ARJNj1Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successv3a4m7AE5TMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginHH4MrGRzyOMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src3764178759/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexziO3ARJNj1Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successv3a4m7AE5TMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutBtWbpDFKKXMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutBtWbpDFKKXMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsRMbXxZkpy9Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsRMbXxZkpy9Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsp8KZaC48PwMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsp8KZaC48PwMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsKDSVJDdWzwMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsKDSVJDdWzwMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsu2sxIrhc3WMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsu2sxIrhc3WMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileruIXVFK2LpMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileruIXVFK2LpMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamyEtKekouS6Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamyEtKekouS6Meta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/manager/team.vue")
  },
  {
    name: marketplaceMvGnjZsEAvMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceMvGnjZsEAvMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src3764178759/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientKHJKtTCt9fMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3764178759/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceMvGnjZsEAvMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceMvGnjZsEAvMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src3764178759/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientKHJKtTCt9fMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3764178759/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribehdtctNx2TnMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribehdtctNx2TnMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clienteLLkQRHrY8Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3764178759/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clienteLLkQRHrY8Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3764178759/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientlZ3fc4qJScMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3764178759/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientlZ3fc4qJScMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3764178759/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyN6wFfeQ8DuMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyN6wFfeQ8DuMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexTreGPBbYgcMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexTreGPBbYgcMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src3764178759/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src3764178759/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93euJhbnybNRMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93euJhbnybNRMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexq4AV2CRfxrMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexq4AV2CRfxrMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueN4enxyAqnaMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueN4enxyAqnaMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successlfBWpMkO6iMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successlfBWpMkO6iMeta || {},
    component: () => import("/codebuild/output/src3764178759/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubccsntgJ5k0Meta?.name,
    path: "/old-page",
    component: component_45stubccsntgJ5k0
  }
]